export const T = {
  en_GB: {
    clientNotFound: "This client could not be found.",
    clientLoadFailed: "The client could not be loaded. Please try again.",
    clients: "Clients",
    removeFromFavourites: "Remove from favourites",
    addToFavourites: "Add to favourites",
    never: "Never",
    created: "Created",
    documentation: "Documentation",
    followUp: "Follow up",
    edit: "Edit",
    delete: "Delete",
    noAdditionalInfo: "No additional client information available. Click Edit to add details.",
    deleteClient: "Delete Client",
    deleteConfirmation: (name: string) =>
      `Are you sure you want to delete "${name}"? This action cannot be undone.`,
    cancel: "Cancel",
    error: "Error",
    failedToDelete: "Failed to delete client",
    ok: "OK",
    today: "Today",
    yesterday: "Yesterday",
    daysAgo: (count: number) => `${count} days ago`,
    monthAgo: "1 month ago",
    monthsAgo: (count: number) => `${count} months ago`,
    yearAgo: "1 year ago",
    yearsAgo: (count: number) => `${count} years ago`,
    hideSSN: "Hide SSN",
    showSSN: "Show SSN",
    yes: "Yes",
    no: "No",
  },
  nb_NO: {
    clientNotFound: "Fant ikke denne kunden.",
    clientLoadFailed: "Kunden kunne ikke lastes. Prøv igjen.",
    clients: "Kunder",
    removeFromFavourites: "Fjern fra favoritter",
    addToFavourites: "Legg til favoritter",
    never: "Aldri",
    created: "Opprettet",
    documentation: "Dokumentasjon",
    followUp: "Følg opp",
    edit: "Rediger",
    delete: "Slett",
    noAdditionalInfo:
      "Ingen tilleggsinformasjon tilgjengelig. Klikk Rediger for a legge til detaljer.",
    deleteClient: "Slett kunde",
    deleteConfirmation: (name: string) =>
      `Er du sikker pa at du vil slette "${name}"? Denne handlingen kan ikke angres.`,
    cancel: "Avbryt",
    error: "Feil",
    failedToDelete: "Kunne ikke slette kunden",
    ok: "OK",
    today: "I dag",
    yesterday: "I gar",
    daysAgo: (count: number) => `${count} dager siden`,
    monthAgo: "1 maned siden",
    monthsAgo: (count: number) => `${count} maneder siden`,
    yearAgo: "1 ar siden",
    yearsAgo: (count: number) => `${count} ar siden`,
    hideSSN: "Skjul personnummer",
    showSSN: "Vis personnummer",
    yes: "Ja",
    no: "Nei",
  },
} as const;

export const ACTIVITY_DATE_LABELS = {
  en_GB: {
    lastLogin: "Last Login",
    lastInfoUpdated: "Last Updated",
    lastFlowActivity: "Last Flow Activity",
    lastFlowCompleted: "Last Flow Completed",
    lastAccountSynced: "Last Account Synced",
    lastSignedDocument: "Last Signed Document",
    createdAt: "Created",
  },
  nb_NO: {
    lastLogin: "Siste innlogging",
    lastInfoUpdated: "Sist oppdatert",
    lastFlowActivity: "Siste flytaktivitet",
    lastFlowCompleted: "Siste fullførte flyt",
    lastAccountSynced: "Siste kontosynkronisering",
    lastSignedDocument: "Siste signerte dokument",
    createdAt: "Opprettet",
  },
} as const;
